module.exports = __webpack_public_path__ + "static/media/theMofG28.2b57a8c3.png";